import { useCallback, useState } from 'react';

interface UseCounterCallbacks {
  increment: () => void;
  decrement: () => void;
  set: (value: number) => void;
}

interface UseCounterOptions {
  mod?: number;
}

export default function useCounter(
  initialValue = 0,
  opts: UseCounterOptions,
): [number, UseCounterCallbacks] {
  const [value, setValue] = useState<number>(initialValue);
  const set = useCallback((newValue: number) => setValue(newValue), []);
  const increment = useCallback(() => {
    setValue((oldValue) => {
      const newValue = oldValue + 1;
      return opts?.mod == null ? newValue : mod(newValue, opts.mod);
    });
  }, [opts?.mod]);
  const decrement = useCallback(() => {
    setValue((oldValue) => {
      const newValue = oldValue - 1;
      return opts?.mod == null ? newValue : mod(newValue, opts.mod);
    });
  }, [opts?.mod]);
  return [value, { set, increment, decrement }];
}

const mod = (n: number, m: number): number => ((n % m) + m) % m;
